import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    countries: [],
    groupsCountries: [],
    typeOfTradingOperation: [],
    transport: [],
    typeImport: [],
    processType: [],
    procedure: [],
    operations: [],
    nsiCountryList: [],
    nsiCountryListWithData: [],
    nsiMeasureOrganProtectedMarket: [],
    nsiIndustry: [],
    nsiBusinessTipsStatusList: [],
    moveDirections: [],
    countryCoverages: [],
    measureTypes: [],
    ttrStatus: [],
    investigationType: [],
    nsiFreeTradeAgreementType: [],
    regions: [],
    regionsPage: null,
    partnerCountry: [],
    regionsSearchId: [],
    partnerCountrySearchId: [],
    chinaProvinces: [],
    chinaProvincesPage: null,
    federalDistrictList: [],
    publicNavigationMenu: [],
    organizationList: [],
  },
};

export const DIRECTIVES = 'directives';

export const DIRECTIVES_ACTIONS_NAME = {
  countriesGet: `${DIRECTIVES}/getCountries`,
  getGroupsCountries: `${DIRECTIVES}/getGroupsCountries`,
  getTypeOfTradingOperation: `${DIRECTIVES}/getTypeOfTradingOperation`,
  getTransport: `${DIRECTIVES}/getTransport`,
  getTypeImport: `${DIRECTIVES}/getTypeImport`,
  getProcessType: `${DIRECTIVES}/getProcessType`,
  getProcedure: `${DIRECTIVES}/getProcedure`,
  getOperations: `${DIRECTIVES}/getOperations`,
  getNsiCountry: `${DIRECTIVES}/getNsiCountry`,
  getNsiCountryWithData: `${DIRECTIVES}/getNsiCountryWithData`,
  getNSIMeasureOrganProtectedMarket: `${DIRECTIVES}/getNSIMeasureOrganProtectedMarket`,
  getNSIIndustry: `${DIRECTIVES}/getNSIIndustry`,
  getNSIMoveDirections: `${DIRECTIVES}/getNSIMoveDirections`,
  getNSICountryCoverages: `${DIRECTIVES}/getNSICountryCoverages`,
  getNSIMeasureTypes: `${DIRECTIVES}/getNSIMeasureTypes`,
  getNSITtrStatus: `${DIRECTIVES}/getNSITtrStatus`,
  getNSIInvestigationType: `${DIRECTIVES}/getNSIInvestigationType`,
  getNsiFreeTradeAgreementType: `${DIRECTIVES}/getNsiFreeTradeAgreementType`,
  getNsiBusinessTipsStatus: `${DIRECTIVES}/getNsiBusinessTipsStatus`,
  getRegions: `${DIRECTIVES}/getRegions`,
  getRegionsPage: `${DIRECTIVES}/getRegionsPage`,
  getPartnerCountry: `${DIRECTIVES}/getPartnerCountry`,
  getRegionsSearchId: `${DIRECTIVES}/getRegionsSearchId`,
  getPartnerCountrySearchId: `${DIRECTIVES}/getPartnerCountrySearchId`,
  getChinaProvinces: `${DIRECTIVES}/getChinaProvinces`,
  getFederalDistricts: `${DIRECTIVES}/getFederalDistricts`,
  getPublicNavigationMenu: `${DIRECTIVES}/getPublicNavigationMenu`,
  getOrganizationList: `${DIRECTIVES}/getOrganizationList`,
};

export const DIRECTIVES_MUTATIONS_NAME = {
  setCountries: 'setCountries',
  setGroupsCountries: 'setGroupsCountries',
  setTypeOfTradingOperation: 'setTypeOfTradingOperation',
  setTransport: 'setTransport',
  setTypeImport: 'setTypeImport',
  setProcessType: 'setProcessType',
  setProcedure: 'setProcedure',
  setOperations: 'setOperations',
  setNsiCountry: 'setNsiCountry',
  setNsiCountryWithData: 'setNsiCountryWithData',
  setNsiBusinessTipsStatusList: 'setNsiBusinessTipsStatusList',
  setMeasureOrganProtectedMarket: 'setMeasureOrganProtectedMarket',
  setIndustry: 'setIndustry',
  setMoveDirections: 'setMoveDirections',
  setCountryCoverages: 'setCountryCoverages',
  setMeasureTypes: 'setMeasureTypes',
  setTtrStatus: 'setTtrStatus',
  setInvestigationType: 'setInvestigationType',
  setNsiFreeTradeAgreementType: 'setNsiFreeTradeAgreementType',
  setRegions: 'setRegions',
  setRegionsPage: `${DIRECTIVES}/setRegionsPage`,
  setPartnerCountry: 'setPartnerCountry',
  setRegionsSearchId: 'setRegionsSearchId',
  setPartnerCountrySearchId: 'setPartnerCountrySearchId',
  setChinaProvinces: 'setChinaProvinces',
  setChinaProvincesPage: `${DIRECTIVES}/setChinaProvincesPage`,
  setFederalDistricts: 'setFederalDistricts',
  setPublicNavigationMenu: `${DIRECTIVES}/setPublicNavigationMenu`,
  setOrganizationList: 'setOrganizationList',
};

export const DIRECTIVES_GETTERS_NAME = {
  getCountriesSelect: `${DIRECTIVES}/getCountriesSelect`,
  getCountriesMultiSelect: `${DIRECTIVES}/getCountriesMultiSelect`,
  getGroupsCountriesMultiSelect: `${DIRECTIVES}/getGroupsCountriesMultiSelect`,
  getTypeOfTradingOperationList: `${DIRECTIVES}/getTypeOfTradingOperationList`,
  getTypeOfTradingOperationMultiSelect: `${DIRECTIVES}/getTypeOfTradingOperationMultiSelect`,
  getTransportList: `${DIRECTIVES}/getTransportList`,
  getTypeImportSelect: `${DIRECTIVES}/getTypeImportSelect`,
  getTypeImportMultiSelect: `${DIRECTIVES}/getTypeImportMultiSelect`,
  getTypeProcess: `${DIRECTIVES}/getTypeProcess`,
  getProcedureList: `${DIRECTIVES}/getProcedureList`,
  getOperationsList: `${DIRECTIVES}/getOperationsList`,
  getNsiCountryList: `${DIRECTIVES}/getNsiCountryList`,
  getNsiCountryListWithData: `${DIRECTIVES}/getNsiCountryListWithData`,
  getCountryNoRussia: `${DIRECTIVES}/getCountryNoRussia`,
  getNSIRequest: `${DIRECTIVES}/getNSIRequest`,
  getNSIMeasureOrganProtectedMarketList: `${DIRECTIVES}/getNSIMeasureOrganProtectedMarketList`,
  getNSIIndustryList: `${DIRECTIVES}/getNSIIndustryList`,
  getNSIMoveDirectionsList: `${DIRECTIVES}/getNSIMoveDirectionsList`,
  getNSICountryCoveragesList: `${DIRECTIVES}/getNSICountryCoveragesList`,
  getNSIMeasureTypesList: `${DIRECTIVES}/getNSIMeasureTypesList`,
  getTtrStatusGroupOptions: `${DIRECTIVES}/getTtrStatusGroupOptions`,
  getNSIInvestigationTypeList: `${DIRECTIVES}/getNSIInvestigationTypeList`,
  getNsiFreeTradeAgreementType: `${DIRECTIVES}/getNsiFreeTradeAgreementType`,
  getNsiBusinessTipsStatusList: `${DIRECTIVES}/getNsiBusinessTipsStatusList`,
  getFederalDistrictList: `${DIRECTIVES}/getFederalDistrictList`,
  getRegionsList: `${DIRECTIVES}/getRegionsList`,
  getRegionsListWithId: `${DIRECTIVES}/getRegionsListWithId`,
  getRegionsPage: `${DIRECTIVES}/getRegionsPage`,
  getPartnerCountryList: `${DIRECTIVES}/getPartnerCountryList`,
  getRegionsSearchIdList: `${DIRECTIVES}/getRegionsSearchIdList`,
  getPartnerCountrySearchIdList: `${DIRECTIVES}/getPartnerCountrySearchIdList`,
  getChinaProvincesList: `${DIRECTIVES}/getChinaProvincesList`,
  getChinaProvincesPage: `${DIRECTIVES}/getChinaProvincesPage`,
  getPublicNavigationMenu: `${DIRECTIVES}/getPublicNavigationMenu`,
  getListOrganizations: `${DIRECTIVES}/getOrganizationList`,
};
